import { render, staticRenderFns } from "./Bar.vue?vue&type=template&id=5a2099cd&scoped=true"
import script from "./Bar.vue?vue&type=script&lang=ts"
export * from "./Bar.vue?vue&type=script&lang=ts"
import style0 from "./Bar.vue?vue&type=style&index=0&id=5a2099cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2099cd",
  null
  
)

export default component.exports